import { Link } from "react-router-dom";

export default function SiteFooter() {
  const scrollTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    <footer className="bg-primary-950 border-t border-primary-900/60">
      <div className="max-w-[1200px] mx-auto px-4 md:px-8 py-12 md:py-16">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-10">
          <div className="md:col-span-1">
            <div className="flex items-center gap-2.5 mb-4">
              <span className="w-9 h-9 flex items-center justify-center rounded-md bg-primary-600 text-accent-300 text-lg">
                <i className="ri-movie-2-line" />
              </span>
              <span className="font-heading font-bold text-foreground-950 text-base">
                美国式禁忌2
              </span>
            </div>
            <p className="text-sm text-foreground-600 leading-relaxed">
              专注于《美国式禁忌2》的剧集介绍、分集剧情解析、角色资料与观众点评，为影迷提供深度而可靠的观剧参考。
            </p>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-900 mb-4">内容导航</h4>
            <ul className="space-y-3 text-sm">
              <li>
                <Link to="/" className="text-foreground-600 hover:text-accent-300 cursor-pointer transition-colors">
                  首页
                </Link>
              </li>
              <li>
                <Link to="/category" className="text-foreground-600 hover:text-accent-300 cursor-pointer transition-colors">
                  剧集列表
                </Link>
              </li>
              <li>
                <Link to="/search" className="text-foreground-600 hover:text-accent-300 cursor-pointer transition-colors">
                  站内搜索
                </Link>
              </li>
              <li>
                <Link to="/#reviews" className="text-foreground-600 hover:text-accent-300 cursor-pointer transition-colors">
                  观众点评
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-900 mb-4">关于与帮助</h4>
            <ul className="space-y-3 text-sm">
              <li>
                <Link to="/about" className="text-foreground-600 hover:text-accent-300 cursor-pointer transition-colors">
                  关于本站
                </Link>
              </li>
              <li>
                <Link to="/feedback" className="text-foreground-600 hover:text-accent-300 cursor-pointer transition-colors">
                  用户反馈
                </Link>
              </li>
              <li>
                <Link to="/about#disclaimer" className="text-foreground-600 hover:text-accent-300 cursor-pointer transition-colors">
                  免责声明
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-900 mb-4">联系方式</h4>
            <ul className="space-y-3 text-sm">
              <li className="flex items-center gap-2 text-foreground-600">
                <i className="ri-mail-line text-accent-400" />
                contact@americantaboo2.example.com
              </li>
              <li className="flex items-center gap-2 text-foreground-600">
                <i className="ri-time-line text-accent-400" />
                内容更新：每周更新
              </li>
            </ul>
            <a
              href="mailto:contact@americantaboo2.example.com"
              className="inline-flex items-center gap-2 mt-4 h-9 px-4 rounded-md bg-primary-600 hover:bg-primary-500 text-background-50 text-sm font-medium whitespace-nowrap cursor-pointer transition-colors"
            >
              <i className="ri-send-plane-line" />
              联系编辑部
            </a>
          </div>
        </div>

        <div className="mt-12 pt-6 border-t border-primary-900/60 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-foreground-600 text-center sm:text-left">
            © 2026 美国式禁忌2 · 影视内容介绍站。本站内容为影视作品介绍与观众讨论，仅作学习交流之用。
          </p>
          <button
            type="button"
            onClick={scrollTop}
            className="flex items-center gap-2 h-9 px-4 rounded-md border border-primary-800 text-foreground-700 hover:text-accent-300 hover:border-accent-500 text-sm whitespace-nowrap cursor-pointer transition-colors"
          >
            <i className="ri-arrow-up-line" />
            回到顶部
          </button>
        </div>
      </div>
    </footer>
  );
}